import React, { Component } from 'react';
import { Row, Col, Modal, ModalHeader, ModalBody } from 'reactstrap';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import { connect } from "react-redux";
import * as actions from '../actions';
import { ScaleLoader } from 'react-spinners';
import { THE_FIELDS, SORT_FIELDS } from './forms/formfields';
import Add from './add';
import Toggle from 'material-ui/Toggle';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import '../style/style.css';

let order = 'desc';
var component;
var fields;

class View extends Component {
    constructor(props) {
      super(props);
      component = this;
      this.state = {
          modal: false,
          row: {},
          planChecked: false,
          freshChecked: false
      };
    }

    toggle = (rowdata) => {
        var newrowdata = rowdata;
        if (fields && !this.state.modal) {
            for (var i = 0; i < fields.length; i++) {
                if (fields[i].type === 'multiselect'){
                    var array = newrowdata[fields[i].name];
                    if (!Array.isArray(array)) {
                        if (array) {
                            array = array.split(',');
                        } else {
                            array = [];
                        }
                    }
                    newrowdata[fields[i].name] = array;
                }
            }
        }

       this.setState({
         modal: !this.state.modal,
         row: newrowdata
       });
     }

    componentDidMount() {
        if (!this.props.dbtype) {
            this.props.callAPIwithSetDB(localStorage.getItem('dbtype'),{action: 'get'})
        } else {
            this.props.callAPI(this.props.dbtype,{action: 'get'});
        }
        window.addEventListener("resize", this.updateDimentions)
    }

    componentWillUnmount() {
       window.removeEventListener("resize", this.updateDimentions);
     }

    updateDimentions = () => {
        this.props.reSize(window.innerWidth,window.innerHeight);
    }

    handleBtnClick = () => {
        if (order === 'desc') {
            this.refs.table.handleSort('asc', 'name');
            order = 'asc';
        } else {
            this.refs.table.handleSort('desc', 'name');
            order = 'desc';
        }
    }

    onAfterDeleteRow(rowKeys) {
        var passbody = {action: 'delete', ids: rowKeys};;
        component.props.callAPI(component.props.dbtype,passbody);
    }

    onRowClick(row) {
        component.toggle(row);// ...
    }

    onDeleteToggle = (e, checked) => {
        this.props.toggleDelete(checked);
    }

    onPlansToggle = (e, checked) => {
        this.setState({planChecked: checked});
        this.setState({freshChecked: false});
        if (checked){
            this.props.filterData(this.props.data,true,['NextSteps','PoA'],'*');
        } else {
            this.props.filterData(this.props.data,false);
        }
    }

    onFreshToggle = (e, checked) => {
        this.setState({freshChecked: checked});
        this.setState({planChecked: false});
        var nowdate = new Date();
        var startdate = new Date(nowdate.getFullYear(),nowdate.getMonth(),nowdate.getDate() - 7);
        if (checked){
            this.props.filterData(this.props.data,true,['Created'],startdate,true);
        } else {
            this.props.filterData(this.props.data,false);
        }
    }

    selectFormatter = (cell,row, enumObject) => {
        return enumObject[cell];
    }

    rowFormatter = (row, rowIdx) => {
        var nowdate = new Date();
        var startdate = new Date(nowdate.getFullYear(),nowdate.getMonth(),nowdate.getDate() - 7);
        var d = row.Created.split("T")[0].split("-");
        var formatedDate = new Date(d[0],(d[1]-1),d[2]);

        return formatedDate >= startdate ? 'table-row-fresh' : 'table-row-stale';
    }

    renderColumns = () => {
        if (!fields) {
            fields = THE_FIELDS[this.props.dbtype];
        }
        var JSXColumns = [
            <TableHeaderColumn key='ID' hidden dataField='ID' isKey dataSort autoValue>ID</TableHeaderColumn>,
            <TableHeaderColumn key='UserID' hidden dataField='UserID' dataSort autoValue>ID</TableHeaderColumn>,
            <TableHeaderColumn key='Created' hidden dataField='Created' dataSort autoValue>ID</TableHeaderColumn>
        ]

        var field;
        var formatfunction;
        var options;

        for (var i = 0; i < fields.length; i++) {
            field = fields[i];
            var hidden = true
            if (field.table){
                if (field.table <= window.innerWidth) {
                    hidden = false
                }
            }

            // Replace values with text labels where the column i stored as an integer
            if (field.dataFormat) {
                formatfunction = this.selectFormatter;
                options = {};
                for (var j = 0; j < field.options.length; j++){
                    options[field.options[j].value] = field.options[j].text;
                }
            } else {
                formatfunction = undefined;
            }

            JSXColumns.push (
                <TableHeaderColumn
                    key={field.name}
                    hidden={hidden}
                    width={field.width}
                    dataField={field.name}
                    dataSort editable={ { type: `${field.type}` } }
                    headerAlign={field.align}
                    dataAlign={field.align}
                    dataFormat = {formatfunction}
                    formatExtraData={options}
                    className='table-header'>
                        {field.label}
                </TableHeaderColumn>
            );
        }

        return JSXColumns;
    };

    renderBootstrapTable = () => {
        var selectRow = {
          mode: 'checkbox',
          bgColor: 'pink',
          hideSelectColumn: !this.props.deleteenabled,
          columnWidth: '1px'
        };
        var options = { afterDeleteRow: this.onAfterDeleteRow,
                        onRowClick: this.onRowClick};
        if (this.props.dbtype){
            options.defaultSortName = SORT_FIELDS[this.props.dbtype].col;
            options.defaultSortOrder = SORT_FIELDS[this.props.dbtype].order;
        };
        if (this.props.dbtype) {
            return (
                <BootstrapTable trClassName = {this.rowFormatter}
                    data={ this.props.filtereddata }
                    selectRow={ selectRow }
                    deleteRow={this.props.deleteenabled}
                    hover
                    options={ options }
                    cellEdit={ this.cellEditProp }
                    version='4'
                    condensed
                    search
                    // exportCSV
                    width
                    ref='table'
                    bordered={ false }>
                      {this.renderColumns()}
                </BootstrapTable>
            )
        }
    }

    styles = {
      labelStyle: {
        color: '#22B48B',
        fontWeight: 'bold',
        textAlign: 'left'
      },
    };

    renderToggles = () => {
        var jsxlist = [];
        if (this.props.dbtype === 'idea'){
            jsxlist.push(
                <MuiThemeProvider key='plantoggle'>
                    <Toggle
                      label="Only Ideas with Plans"
                      labelPosition="right"
                      labelStyle={this.styles.labelStyle}
                      onToggle={this.onPlansToggle}
                      toggled={this.state.planChecked}
                    />
                </MuiThemeProvider>
            );
        }
        jsxlist.push(
            <MuiThemeProvider key='freshtoggle'>
                <Toggle
                  label="Fresh Entries"
                  labelPosition="right"
                  labelStyle={this.styles.labelStyle}
                  onToggle={this.onFreshToggle}
                  toggled={this.state.freshChecked}
                />
            </MuiThemeProvider>
        );
        return jsxlist;
    }

    showSettings (event) {
        event.preventDefault();
      }

    renderTable = () => {
        if (this.props.loading) {
            return (
                <div className='sweet-loading'>
                    <Row className="spacer-lg"></Row>
                    <Row className="spacer-lg"></Row>
                    <ScaleLoader
                         color={'#36D7B7'}
                         loading={this.props.loading}
                    />
                 </div>
            )
        } else {
            return (
                <div className = "table_div">
                    <Row>
                        <Col>
                            {this.renderToggles()}
                            {this.renderBootstrapTable()}
                            <Row className="spacer-lg"></Row>
                            <Row className="spacer-lg"></Row>
                            <Row className="spacer-lg"></Row>
                            <MuiThemeProvider>
                                <Toggle
                                  label="Enable Deletion"
                                  labelPosition="right"
                                  labelStyle={this.styles.labelStyle}
                                  onToggle={this.onDeleteToggle}
                                />
                            </MuiThemeProvider>
                        </Col>
                    </Row>

                </div>
            )
        }
    }

    capitalizeFirstLetter = (string) => {
        if (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

    renderModalForm = () => {
        return (
            <div>
                <Add initialValues={this.state.row} isModal={true}/>
            </div>
        )
    }

    render() {
        var labeltext = this.props.dbtype;
        if (labeltext === "opportunity") {
            labeltext = "opportunitie";
        }
        return (
            <div className="viewideas">
                <div className="spacer-lg"></div>
                <h3 className="view-label">{`View ${this.capitalizeFirstLetter(labeltext)}s`}</h3>
                <hr className="my-2" />
                {this.renderTable()}
                <Modal isOpen={this.state.modal} toggle={this.toggle} className="modal-lg">
                  <ModalHeader toggle={this.toggle}>Edit Entry</ModalHeader>
                  <ModalBody>
                    {this.renderModalForm()}
                  </ModalBody>
                </Modal>
            </div>
        )
    }
}

function mapStateToProps(state) {
    return { data: state.app.data,
            filtereddata:  state.app.filtereddata,
            loading: state.app.loading,
            dbtype: state.app.dbtype,
            width: state.app.width,
            deleteenabled: state.app.deleteenabled};
}

export default connect(mapStateToProps, actions)(View);



// WEBPACK FOOTER //
// ./src/pages/view.js